// Initialize quantity utilities
function initQuantityUtilities() {
  const quantityUtilities = document.querySelectorAll('.quantity-utility');
  
  quantityUtilities.forEach(utility => {
    const sectionId = utility.getAttribute('data-section-id');
    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    const utilityButtons = utility.querySelectorAll('.quantity-utility__button');
    
    // Check if it is inside a wrapper with data-product-utils
    const productCategoryWrapper = utility.closest('[data-product-utils]');
    let quantityProperty;
    let productCheckbox;
    
    // Variables for property management
    let productForm;
    let productCategory;
    let propertyName;
    
    // If inside a product category wrapper, setup property management
    if (productCategoryWrapper) {
      // Find the checkbox for this product
      productCheckbox = productCategoryWrapper.querySelector('.product-utils-checkbox');
      
      // Find the correct form for this product
      const section = utility.closest('section');
      if (section) {
        productForm = section.querySelector('form[data-type="add-to-cart-form"]');
        if (productForm) {
          productCategory = productCategoryWrapper.dataset.productUtils;
          propertyName = `properties[${productCategory} Quantity]`;
        }
      }
    }
    
    // Function to get current value
    function getCurrentValue() {
      // If checkbox exists and is not checked, return 0
      if (productCheckbox && !productCheckbox.checked) {
        return '0';
      }
      
      if (quantityInput) {
        return quantityInput.value;
      }
      return utility.getAttribute('data-quantity-selected') || '1';
    }
    
    // Function to manage property input (create/remove based on value)
    function managePropertyInput(value) {
      if (!productForm || !propertyName) return;
      
      const currentValue = String(value || getCurrentValue());
      const isZero = currentValue === '0' || currentValue === '';
      
      // Check if property input exists
      quantityProperty = productForm.querySelector(`input[name="${propertyName}"]`);
      
      if (isZero) {
        // Remove property input if quantity is 0
        if (quantityProperty) {
          quantityProperty.remove();
          quantityProperty = null;
        }
      } else {
        // Create or update property input if quantity > 0
        if (!quantityProperty) {
          quantityProperty = document.createElement('input');
          quantityProperty.type = 'hidden';
          quantityProperty.name = propertyName;
          productForm.appendChild(quantityProperty);
        }
        quantityProperty.value = currentValue;
      }
      
      // Update subscription prices immediately
      if (typeof window.updateSubscriptionPrices === 'function') {
        window.updateSubscriptionPrices();
      }
    }
    
    // Function to set current value
    function setCurrentValue(value) {
      utility.setAttribute('data-quantity-selected', value);
      if (quantityInput) {
        quantityInput.value = value;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Manage property input (create/remove based on value)
      managePropertyInput(value);
    }
    
    // Function to update active state
    function updateActiveButton() {
      const currentValue = getCurrentValue();
      utilityButtons.forEach(btn => {
        if (btn.getAttribute('data-quantity') === currentValue) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
      // Manage property input (create/remove based on value)
      managePropertyInput(currentValue);
    }
    
    // Set initial value based on checkbox state
    if (productCheckbox && !productCheckbox.checked) {
      utility.setAttribute('data-quantity-selected', '0');
    }
    
    // Set initial active state
    updateActiveButton();
    
    // Listen to changes on quantity input (if exists)
    if (quantityInput) {
      quantityInput.addEventListener('input', updateActiveButton);
      quantityInput.addEventListener('change', updateActiveButton);
    }
    
    // Listen to changes on checkbox (if exists)
    if (productCheckbox) {
      productCheckbox.addEventListener('change', function() {
        // When checkbox is checked, set quantity to 1; when unchecked, set to 0
        const newValue = this.checked ? '1' : '0';
        utility.setAttribute('data-quantity-selected', newValue);
        if (quantityInput) {
          quantityInput.value = newValue;
        }
        updateActiveButton();
        
        // Update images when checkbox changes
        const totalQuantity = calculateTotalQuantity();
        console.log('Checkbox changed - Total quantity:', totalQuantity);
        updateProductImages(sectionId, totalQuantity);
      });
    }
    
    // Handle button clicks
    utilityButtons.forEach(button => {
      button.addEventListener('click', function() {
        const quantity = this.getAttribute('data-quantity');
        console.log('Quantity button clicked:', quantity, 'sectionId:', sectionId);
        setCurrentValue(quantity);
        updateActiveButton();
        
        // Calculate total quantity from both Espresso and Filter
        const totalQuantity = calculateTotalQuantity();
        console.log('Total quantity (Espresso + Filter):', totalQuantity);
        
        // Update product images with the total quantity
        updateProductImages(sectionId, totalQuantity);
      });
    });
  });
  
  // Set initial image on page load based on default quantities
  const initialTotalQuantity = calculateTotalQuantity();
  console.log('Initial total quantity on page load:', initialTotalQuantity);
  updateProductImages('initial', initialTotalQuantity);
}

// Function to calculate total quantity from Espresso and Filter
function calculateTotalQuantity() {
  // Find Espresso and Filter quantity utilities
  const espressoUtility = document.querySelector('[data-section-id="Espresso"]');
  const filterUtility = document.querySelector('[data-section-id="Filter"]');
  
  let espressoQty = 0;
  let filterQty = 0;
  
  if (espressoUtility) {
    const espressoValue = espressoUtility.getAttribute('data-quantity-selected');
    espressoQty = parseInt(espressoValue || '0');
    console.log('Espresso quantity:', espressoQty, 'from value:', espressoValue);
  }
  
  if (filterUtility) {
    const filterValue = filterUtility.getAttribute('data-quantity-selected');
    filterQty = parseInt(filterValue || '0');
    console.log('Filter quantity:', filterQty, 'from value:', filterValue);
  }
  
  const total = espressoQty + filterQty;
  console.log('Total calculation:', espressoQty, '+', filterQty, '=', total);
  
  return total;
}

// Function to update product images based on selected quantity
function updateProductImages(sectionId, quantity) {
  console.log('updateProductImages called with sectionId:', sectionId, 'quantity:', quantity);
  
  // Keep track of processed images to avoid duplicates
  const processedImages = new Set();
  
  // Find all product media wrappers on the page
  const mediaWrappers = document.querySelectorAll('.product__media-wrapper, media-gallery');
  console.log('Found media wrappers:', mediaWrappers.length);
  
  // Update images in each media wrapper
  mediaWrappers.forEach(wrapper => {
    const images = wrapper.querySelectorAll('img');
    console.log('Found images in media wrapper:', images.length);
    images.forEach(img => {
      if (!processedImages.has(img)) {
        updateImageSource(img, quantity);
        processedImages.add(img);
      }
    });
  });
  
  // Also find any remaining product images that weren't in media wrappers
  const allProductImages = document.querySelectorAll('[data-product-image], [data-thumbnail-image], [data-sticky-bar-image]');
  console.log('Found additional product images:', allProductImages.length);
  allProductImages.forEach(img => {
    if (!processedImages.has(img)) {
      updateImageSource(img, quantity);
      processedImages.add(img);
    }
  });
  
  console.log('Total images processed:', processedImages.size);
}

// Function to update all product images on the page (simplified)
function updateAllProductImages(quantity) {
  console.log('Updating all product images with quantity:', quantity);
  const allImages = document.querySelectorAll('img');
  console.log('Found images:', allImages.length);
  
  allImages.forEach(img => {
    updateImageSource(img, quantity);
  });
}

// Function to update a single image source
function updateImageSource(img, quantity) {
  if (!img) {
    console.log('No image provided');
    return;
  }
  
  // Get the current image src
  const currentSrc = img.getAttribute('src');
  console.log('Processing image with src:', currentSrc);
  
  if (!currentSrc) {
    console.log('No src attribute found');
    return;
  }
  
  // Check if the image filename contains a pattern like "X-bags-"
  const bagsPattern = /(\d+)-bags-/i;
  const match = currentSrc.match(bagsPattern);
  console.log('Pattern match:', match);
  
  if (match) {
    console.log('Found bags pattern, current number:', match[1]);
    
    // Replace the number with the new quantity in the entire URL
    const newSrc = currentSrc.replace(bagsPattern, `${quantity}-bags-`);
    console.log('New src:', newSrc);
    
    // Add a fade effect for smooth transition
    img.style.transition = 'opacity 0.3s ease-in-out';
    img.style.opacity = '0.5';
    
    // Update the image source
    img.setAttribute('src', newSrc);
    
    // Update srcset if it exists
    if (img.hasAttribute('srcset')) {
      const currentSrcset = img.getAttribute('srcset');
      // Replace all occurrences in the srcset (handles multiple widths)
      const newSrcset = currentSrcset.replace(new RegExp(bagsPattern, 'gi'), `${quantity}-bags-`);
      img.setAttribute('srcset', newSrcset);
      console.log('Updated srcset:', newSrcset);
    }
    
    // Restore opacity when loaded
    const fadeIn = function() {
      img.style.opacity = '1';
      console.log('Image loaded successfully:', newSrc);
      img.removeEventListener('load', fadeIn);
      img.removeEventListener('error', handleError);
    };
    
    // Handle load errors
    const handleError = function() {
      img.style.opacity = '1';
      console.error('Failed to load image:', newSrc);
      console.error('Make sure the file exists in Shopify with this exact name:', newSrc.split('/').pop());
      img.removeEventListener('load', fadeIn);
      img.removeEventListener('error', handleError);
    };
    
    img.addEventListener('load', fadeIn);
    img.addEventListener('error', handleError);
  } else {
    // Check if this is a product image that could be converted to use the bags pattern
    if (currentSrc.includes('fabrica') && currentSrc.includes('coffee') && 
        (currentSrc.includes('subscription') || currentSrc.includes('product'))) {
      console.log('Found product image without bags pattern. You need to:');
      console.log('1. Go to your Shopify product settings');
      console.log('2. Replace the current product image with one of your numbered images like:');
      console.log('   "1-bags-monthly-specialty-...-fabrica-coffee-roasters"');
      console.log('Current image:', currentSrc.split('/').pop());
    } else {
      console.log('No bags pattern found in filename:', currentSrc);
    }
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initQuantityUtilities();
});

// Expose globally for dynamic content
window.initQuantityUtilities = initQuantityUtilities;